export default "__VITE_ASSET__BX$7kbc7__"